import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import ScrollDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ScrollUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Box, Button } from "@mui/material";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import MaLogoBM from "../../../../asset/images/MaLogoBM.png";
import MaLogoBMM from "../../../../asset/images/MaLogoBMM.png";
import MaLogoWMM from "../../../../asset/images/MaLogoWMM.png";
import tradeSenceLogoBM from "../../../../asset/images/tradeSenceLogoBM.png";
import tradeSenceLogoWM from "../../../../asset/images/tradeSenceLogoWM.png";
import {
  ERROR_MODE,
  MESSAGING_MODE,
  PUBLIC_MODE,
} from "../../../constants/generalConstants";
import { HOME_PAGE_ROUTE } from "../../../constants/routerConstants";
import { useAuth } from "../../../hooks/useAuth";
import { AuthContext } from "../../general/TSAuthProvider";
import { useTSData } from "../../general/TSDataContext";
import LoginDialog from "../LoginDialog";
import SpinnerUi from "../SpinnerUI";
import TSGrid from "../TSGrid";
import LabelRoute from "./LabelRoute";
import { MODE_CONNECTE, MODE_NON_CONNECTE } from "./NavConstants";
import { ProfileLogo } from "./ProfileLogo";

const NavBarDynamic = ({ modeBg, isMobile, isMidium, routes = [] }) => {
  const { isAuthenticated } = useAuth();
  const { openLoginDialog, setOpenLoginDialog } = useContext(AuthContext);
  const {
    mode: modeApp,
    openHistoriqueDialog,
    setOpenHistoriqueDialog,
  } = useTSData();
  const navigate = useNavigate();

  const LeftSide = () => {
    if (modeApp === MESSAGING_MODE) {
      if(isMobile) 
        return <FormatAlignLeftIcon
          sx={{
            color: "black",
            cursor: "pointer",
            width: "30px",
            mt: "40px",
            ml: "10px",
          }}
          onClick={() => {
            setOpenHistoriqueDialog(true)
          }}
        />
      if (isAuthenticated && !isMobile)
        return (
          <Button
            variant="text"
            color="primary"
            onClick={() => {}}
            sx={{
              width: "90px",
              textAlign: "center",
              padding: 0,
              fontSize: "12px",
              mt: 2,
              ml: isAuthenticated ? "29vw" : "18vw",
            }}
          ></Button>
        );
    } else {
      let image =
        modeBg === "light" || modeApp === ERROR_MODE ? MaLogoWMM : MaLogoBM;
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          {isMobile ? (
            <FormatAlignLeftIcon
              sx={{
                color: "white",
                cursor: "pointer",
                width: "30px",
                mt: "40px",
                ml: "10px",
              }}
            />
          ) : (
            <img
              alt="moroccoLogo"    
              width={isMobile ? "153px" : isMidium ? "340px" : "363px"}
              height={isMobile ? "141px" : isMidium ? "150px" : "162px"}
              style={{
                paddingTop: "40px",
                paddingLeft: isMobile ? "15px" : "40px",
                cursor: "pointer",
                width: isMobile ? "153px" : isMidium ? "340px" : "360px",
                height: isMobile ? "141px" : isMidium ? "150px" : "162px",
              }}
              src={image}
              onClick={() => navigate(HOME_PAGE_ROUTE)}
            />
          )}
        </div>
      );
    }
  };

  const RightSide = () => {
    if (modeApp === MESSAGING_MODE) {
      if (isAuthenticated) {
        return <ProfileLogo isMobile={isMobile} />;
      } else {
        return (
          <Button
            variant="text"
            color="primary"
            onClick={() => {
              setOpenLoginDialog(true);
            }}
            sx={{
              textAlign: "center",
              padding: 0,
              fontSize: isMobile ? "7px" : "12px",
              cursor: "pointer",
              zIndex: 10,
              mr: isMobile ? 3 : 5,
              ...(!isMobile && { mt: 2 }),
            }}
          >
            Connexion
          </Button>
        );
      }
    } else {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "center",
            marginTop: "10px",
            ...(isMidium && { marginLeft: "60%" }),
          }}
        >
          <img
            alt="moroccoLogo"
            width="215px"
            height="51px"
            style={{
              width: "215px",
              height: "51px",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              ...(isMobile && {
                width: "50px",
                height: "54px",
              }),
            }}
            src={
              isMobile
                ? MaLogoBMM
                : modeApp != PUBLIC_MODE || modeBg === "light"
                ? tradeSenceLogoWM
                : tradeSenceLogoBM
            }
            //onClick={() => navigate(HOME_PAGE_ROUTE)}
          />
        </div>
      );
    }
  };

  return (
    <>
      <TSGrid container >
        {isMobile && 1 == 3 && modeApp == MESSAGING_MODE && (
          <TSGrid item xs={12}>
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {!openHistoriqueDialog ? (
                <ScrollUpIcon
                  sx={{ fontSize: 30, color: "#7E7E7E" }}
                  onClick={() => setOpenHistoriqueDialog(true)}
                />
              ) : (
                <ScrollDownIcon
                  sx={{ fontSize: 30, color: "#7E7E7E" }}
                  onClick={() => setOpenHistoriqueDialog(true)}
                />
              )}
            </Box>
          </TSGrid>
        )}

        {(isMobile || isMidium) && (
          <TSGrid item xs={12}>
            <Box
              sx={{
                width: "80%",
                height: "100%",
                marginLeft: "20px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 1,
              }}
            >
              {routes
                .filter((route) => {
                  if (modeApp != MESSAGING_MODE) {
                    return isAuthenticated
                      ? route.mode.includes(MODE_CONNECTE)
                      : route.mode.includes(MODE_NON_CONNECTE);
                  }
                  return false;
                })
                .map((route, index) => (
                  <LabelRoute
                    key={index}
                    isMobile={isMobile}
                    {...route}
                    setOpenLoginDialog={setOpenLoginDialog}
                  />
                ))}
            </Box>
          </TSGrid>
        )}
        <TSGrid item xs={12} sx={{ ...(isMobile && { marginTop: "-10px" }) }}>
          <TSGrid
            container
            sx={{
              justifyContent: "space-around",
              ...(isMobile && {justifyContent: "center"})
            }}
          >
            <TSGrid item xs={3}>
              <LeftSide />
            </TSGrid>
            {isMobile  && (
              <TSGrid item xs={5}>
                <Box
                  component="img"
                  src={modeApp == MESSAGING_MODE ? tradeSenceLogoWM : tradeSenceLogoBM}
                  onClick={() => navigate(HOME_PAGE_ROUTE)}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "35px",
                    width: "120px",
                    height: "28px",
                  }}
                />
              </TSGrid>
            )}
            {!isMobile && !isMidium && (
              <TSGrid item xs={6}>
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    marginTop: "20px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  {routes
                    .filter((route) => {
                      if (modeApp != MESSAGING_MODE) {
                        return isAuthenticated
                          ? route.mode.includes(MODE_CONNECTE)
                          : route.mode.includes(MODE_NON_CONNECTE);
                      }
                      return false;
                    })
                    .map((route, index) => (
                      <LabelRoute
                        key={index}
                        {...route}
                        setOpenLoginDialog={setOpenLoginDialog}
                      />
                    ))}
                </Box>
              </TSGrid>
            )}
            <TSGrid
              item
              xs={3}
              sx={{
                display: "flex",
                marginTop: "20px",
                justifyContent: modeApp === MESSAGING_MODE ? "end" : "center",
                alignItems: "center",
                ...isMobile && modeApp === MESSAGING_MODE && { paddingTop: "20px" },
              }}
            >
              <RightSide />
            </TSGrid>
          </TSGrid>
        </TSGrid>
      </TSGrid>
      {!isAuthenticated && (
        <SpinnerUi>
          <LoginDialog
            open={openLoginDialog}
            onClose={() => {
              setOpenLoginDialog(false);
            }}
          />
        </SpinnerUi>
      )}
    </>
  );
};

export default NavBarDynamic;
